import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.PowerLine = function() {
  WRAP.Renderer.GeoJSONExt.call(this);

  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  const superDraw = this.draw;
  let check;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    check = {};
    superDraw.apply(this, arguments);
  }

  this.drawFeature = function(layer, item, prop, ts) {
    const geo = item;
    const style = ts;
    if ( prop.preferred_route_type ) {
      return;
    }
    if (!!check[prop.gid]) {
      return;
    }
    check[prop.gid] = true;

    let currentArray = [];
    const coordinates = prop.fixes.reduce((accumulator, currentValue) => {
      if (currentArray.length === 0) {
        accumulator.push(currentArray);
      }
      currentArray.push(currentValue);
      return accumulator;
    }, []);

    const featureLine = new WRAP.Geo.Feature.GeoLine({
      path: coordinates,
      strokeStyle: style.line_color,
      lineWidth: style.line_width,
      geodesic: true,
      method: style.line_method
    });
    
    addFeature(layer, featureLine, geo, undefined);
  }
};
/* eslint-enable */